<div class="ui-tab" :class="styleClass">
  <ul class="tab-title-block">
    <li :id="item.gtmId ?  'GTM'+item.gtmId : item.val " @click="onClickTab($event, index, item)" 
    class="tab-item GTMClass_preventPointerEvent GTM__Tab" v-for="(item, index) in state.tabList" :class="{'active': state.activeIndex === index || state.activeIndex === item.val, disabled: item.disabled }">
      <a class="tab-text" href="#" :tabindex="item.disabled ? -1 : 0">{{item.isI18n ? $t(item.isI18n) : item.name}}</a>
      <span class="text-alertText" v-if="item.alertText  && !item.disabled && item.alertText!=0">{{item.alertText}}</span>
    </li>
  </ul>
</div>